import React, { Component } from 'react';
import SideMenuLand from '../../components/SideMenuLand/SideMenuLand';
import LandBg from '../../components/LandBg/LandBg';
import styled from 'styled-components';
import InfoPopulation from '../../components/InfoPopulation/InfoPopulation';
import InfoFlorafauna from '../../components/InfoFlorafauna/InfoFlorafauna';
import InfoAgriculture from '../../components/InfoAgriculture/InfoAgriculture';
import InfoCleanwater from '../../components/InfoCleanwater/InfoCleanwater';
import InfoArcticicemin from '../../components/InfoArcticicemin/InfoArcticicemin';
import InfoTemperaturerise from '../../components/InfoTemperaturerise/InfoTemperaturerise';
import AskLand from '../../components/AskLand/AskLand';
import {Link} from 'react-router-dom';

const Tree = styled.p`
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  font-family:roboto;
  font-size: 1.5rem;
  font-weight:300;
  color: #ffffff;
  margin: 0em 0em 0.9em;
  letter-spacing: .6px;
  margin-left:0px;
  
`;

const Stacker= styled.div`
  display: flex;
  flex-direction:row;
  height: auto;
  justify-content: space-around;
  margin-top:64px;
  @media (max-width: 1130px) {
    flex-direction: column;
  }
`;
const Left = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  display:flex;
  justify-content:center;
`;

const Threat = styled.div`
    width:40vw;
  align-self:center;
  @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Right = styled.div`
    display:flex;
  justify-content:center;
`;

const Impacts = styled.div`
  width:40vw;
  flex-direction:column;
  justify-content:center;

    @media (max-width: 1130px) {
    width:85%;
  }
   @media (max-width: 768px) {
    width:100%;
  }
`;

const Contentwrapper = styled.div`
  margin-left:15px;
  margin-top:15px;
  margin-right:15px;
  margin-bottom:15px;

`;

const Impactwrapper = styled.div`
  margin-left:0px;
  margin-top:15px;
  margin-right:0px;
  margin-bottom:15px;
    transform: scale(1);
  transition: all 0.5s;
      &:hover {
  transform: scale(1.04);
    transition: all 0.5s;
  
}
`;



class Land extends Component{

askearth= ()=> {
          window.dexterApi.open();
          window.dexterApi.replyTo('have rising temperatures compromised life on land');
        }
  render(){

    return(
      
        <body> 

          <SideMenuLand />
          <LandBg/>
          
          
          
          
          <Stacker>
            
      <Contentwrapper>
          <Left>
           <Threat>  
           <Contentwrapper>
          <Tree>Land/</Tree>         
          </Contentwrapper>        
              <Impactwrapper><Link onClick={this.askearth}><AskLand/></Link></Impactwrapper>
           </Threat>
          </Left>
      </Contentwrapper>
     
      <Contentwrapper>
          <Right>
           <Impacts>
 
            <Impactwrapper><Link to="/Land_Population"><InfoPopulation/></Link></Impactwrapper>  

            <Impactwrapper><Link to="/Land_Agriculture"><InfoAgriculture/></Link></Impactwrapper>
            <Impactwrapper><Link to="/Land_Temperature-rise"><InfoTemperaturerise/></Link></Impactwrapper>
            <Impactwrapper><Link to="/Land_Clean-water"><InfoCleanwater/></Link></Impactwrapper>   
            <Impactwrapper><Link to="/Land_Arctic-ice-minimum"><InfoArcticicemin/></Link></Impactwrapper>  

           </Impacts>
          </Right> 
      </Contentwrapper>

      </Stacker>


                  
          
        </body>
      
      );

  } 
}

export default Land;